import { useState, useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import { PullToRefresh, Swiper, Button } from 'antd-mobile'
import { POST } from '../../util/http'
import ComNumber from '../../components/com-number/com-number'
import ComImage from '../../components/com-image/com-image'
import './home.less'

const globalData = [
  { name: '已交付车辆', filed: 'total_property' },
  { name: '已铺设换电柜', filed: 'charging_cabinet_num' },
  { name: '昨日换电次数', filed: 'yesterday_exchange_count' },
  { name: '昨日换电电量 (Ah)', filed: 'yesterday_electricity' },
  { name: '累计换电次数', filed: 'total_exchange_count' },
  { name: '累计换电电量 (Ah)', filed: 'total_electricity' }
]
const incomePart = [
  { name: '本月收益', filed: 'monthProfit' },
  { name: '可提现', filed: 'withdrawalAmount' },
  { name: '累计收益', filed: 'totalProfit' }
]
const propertyPart = [
  { name: '我的电摩', filed: 'propertyNum' },
  { name: '行驶中', filed: 'drivingNum' },
  { name: '停车中', filed: 'stopNum' }
]

const Index = () => {
  const router = useHistory();
  let [state, setState] = useState({
    bannerList: [{ id: 1, url: `https://frontend-mam.oss-cn-hangzhou.aliyuncs.com/MotorRWA/rwa_indexbg.png` }],
    globalData: {},
    infos: {},
    propertyInfos: {},
    isGM: window.localStorage.getItem('isGM')==1,    //当前账号是否用于演示 1:是 0:否
  })
  useEffect(() => {
    getGlobalData();
    getUserProfitOverview();
    getUsersProperty();
  }, [])

  const onRefresh = (e) => {
    getGlobalData('refresh');
    getUserProfitOverview('refresh');
    getUsersProperty('refresh');
  }
  const setData = (obj={}) => {
    setState(st => ({ ...st, ...obj }));
  }
  const getSessionData = (key, setname) => {    //数据加载比较慢，优先缓存中拿数据
    let _sessData = window.sessionStorage.getItem(key), _key = setname || key;
    _sessData = (_sessData && JSON.parse(_sessData)) || null;
    _sessData && setData({ [_key]: { ..._sessData }});
    return !!_sessData;
  }
  const getGlobalData = async (gType) => {    //只有用于演示的账号才需要展示看板数据
    if (!state.isGM) return;
    if (getSessionData('globalData') && !gType) return;

    const res = await POST('getGlobalData', {}, false);
    let _data = { ...state.globalData, ...(res.data || {}) };
    setData({ globalData: _data});
    window.sessionStorage.setItem('globalData', JSON.stringify(_data));
  }
  const getUserProfitOverview = async (gType) => {
    if (getSessionData('profitInfos', 'infos') && !gType) return;

    const res = await POST('getUserProfitOverview', {}, false);
    let { monthProfit, withdrawalAmount, totalProfit } = res.data || {};
    let _str = `${(monthProfit||0)}${(withdrawalAmount||0)}${(totalProfit||0)}`.replace(/\./ig, '');
    let _data = { ...state.infos, monthProfit, withdrawalAmount, totalProfit, isLong: _str.length>20 };
    setData({ infos: _data});
    window.sessionStorage.setItem('profitInfos', JSON.stringify(_data));
  }
  const getUsersProperty = async (gType) => {
    if (getSessionData('propertyInfos') && !gType) return;

    const res = await POST('getUserPropertyOverview', {});
    let { propertyNum, drivingNum, stopNum } = res.data || {};
    let _data = { ...state.propertyInfos, propertyNum, drivingNum, stopNum };
    setData({ propertyInfos: _data});
    window.sessionStorage.setItem('propertyInfos', JSON.stringify(_data));
  }
  const toPage = (path) => {    //申请提现 / 我要认购
    router.push({ pathname: path });
  }

  return (
    <div className={`home-wrap ${state.isGM?'home-gm-wrap':''}`}>
      <PullToRefresh onRefresh={onRefresh}>
        {!state.bannerList.length ? '' : 
          <Swiper className="part banner-part" loop>
            {state.bannerList.map((item, index) => 
              <Swiper.Item key={index}>
                <ComImage url={item.url} width='6.7' height='2.8' loadbgColor='none'></ComImage>
              </Swiper.Item>
            )}
          </Swiper>
        }
        {!state.isGM ? '' : 
          <div className="part globaldata-part">
            <h3 className='title'>资产运营概览</h3>
            <ul className='p-list gb-list cflex'>
              {globalData.map(item => 
                <li className='p-item cflex' key={item.name}>
                  <div className="val-box lflex">
                    <ComNumber number={state.globalData[item.filed]||0} isComma={true}></ComNumber>
                  </div>
                  <p className='vtitle'>{item.name}</p>
                </li>
              )}
            </ul>
          </div>
        }
        <div className="part income-part">
          <h3 className='title'>收益概览 (MOP)</h3>
          <ul className='p-list cflex'>
            {incomePart.map(item => 
              <li className='p-item cflex' key={item.name}>
                <div className="val-box lflex">
                  <ComNumber className={`${state.infos.isLong?'sm-nums':''}`} number={state.infos[item.filed]||0} isComma={true}></ComNumber>
                </div>
                <p className='vtitle'>{item.name}</p>
              </li>
            )}
          </ul>
          {state.isGM ? '' : <Button className='btn pbtn' onClick={() => toPage('/withdraw')}>申请提现</Button>}
        </div>
        <div className="part property-part">
          <h3 className='title'>资产概览</h3>
          <ul className='p-list cflex'>
            {propertyPart.map(item => 
              <li className='p-item cflex' key={item.name}>
                <div className="val-box lflex">
                  <ComNumber number={state.propertyInfos[item.filed]||0} isComma={true}></ComNumber>
                </div>
                <p className='vtitle'>{item.name}</p>
              </li>
            )}
          </ul>
          {state.isGM ? '' : <Button className='btn pbtn' onClick={() => toPage('/buyProperty')}>认购资产</Button>}
        </div>
      </PullToRefresh>
    </div>
  )
}

export default Index;